export const LOGIN_PS = 'password'
export const REGISTER_PS = 'Password'
export const REGISTER_CPS = 'Repeat Password'
